export const BOOKING_STATUS = {
  created: "created",               
  accepted: "acceptedByOwner",
  declined: "declinedByOwner",
  declinedBySystem: "declinedBySystem",
  cancelled: "cancelledByTenant",
  pending_owner_confirmation: "pendingForOwnerConfirmation" //NB! Phased out, only for backward compatibility!
};

export const BOOKING_PAYMENT_STATUS = {
    payment_failed: "paymentFailed",
    payment_cancelled: "paymentCancelled",
    payment_refunded: "paymentRefunded",
    payment_success: "paymentSuccess",
};

export const BOOKING_CONTRACT_STATUS = {
    contract_signed_tenant: "contractSignedByTenant",
    contract_signed_owner: "contractSignedByOwner",
    contract_signed: "inContract",
    contract_ended: "contractEnded",
    contract_cancelled: "contractCancelled",
};

export const ALLOWED_BOOKINGS_STATUSES = Object.values(BOOKING_STATUS);

export const ALLOWED_BOOKING_PAYMENT_STATUSES = Object.values(BOOKING_PAYMENT_STATUS);

export const ALLOWED_BOOKING_CONTRACT_STATUSES = Object.values(BOOKING_CONTRACT_STATUS);


// Should tenant see the booking fee payment option again on the Booking view
export const askBookingApplicationFeePayment=({ status, paymentStatus }, ownerViewing)=>{
  if(ownerViewing) return false
  if(status === BOOKING_STATUS.pending_owner_confirmation) return false // backward compatibility

  if(!paymentStatus) return true
  if(paymentStatus === BOOKING_PAYMENT_STATUS.payment_failed) return true
  if(paymentStatus === BOOKING_PAYMENT_STATUS.payment_cancelled) return true

  return false
}

// Is the booking considered to be active and operational or just history
// TODO: move this variable to server side on a separete field: "alive: false"
export const isBookingDead=({ status: bookingStatus, paymentStatus, contractStatus })=>{
  if(bookingStatus === BOOKING_STATUS.declined) return true
  if(bookingStatus === BOOKING_STATUS.cancelled) return true
  if(paymentStatus === BOOKING_PAYMENT_STATUS.payment_refunded) return true
  if(contractStatus === BOOKING_CONTRACT_STATUS.contract_ended) return true
  if(contractStatus === BOOKING_CONTRACT_STATUS.contract_cancelled) return true
  return false
}

export const isBookingPendingForOwnerConfirmation=({ status, paymentStatus })=>{
  if(status === BOOKING_STATUS.pending_owner_confirmation) return true // backward compatibility
  if(status === BOOKING_STATUS.created && paymentStatus === BOOKING_PAYMENT_STATUS.payment_success) return true
  return false
}

// Should user see the payment details of the owner.
export const shouldShowPaymentDetails=({ paymentStatus, deal, ownerViewing })=>{
  if(ownerViewing) return false
  if(deal.status === BOOKING_STATUS.pending_owner_confirmation) return false // backward compatibility
  if(deal.status === BOOKING_STATUS.accepted) return true
  return false
}

// Should user see the contract details.
export const shouldShowContractDetails=({ status: bookingStatus, contractStatus })=>{
    if(bookingStatus === BOOKING_STATUS.accepted) return true
    if(contractStatus === BOOKING_CONTRACT_STATUS.contract_signed_tenant) return true
    if(contractStatus === BOOKING_CONTRACT_STATUS.contract_signed_owner) return true
    if(contractStatus === BOOKING_CONTRACT_STATUS.contract_signed) return true
    return false
}

export const getCleaningFee = (booking, pricingRules, listing) => {
  var cleaningFee = ""
  var cleaningFeeApplies = booking.agreedDeal.stayLength.totalNrOfDays <= pricingRules.max_days_when_cleaning_fee
  if(listing.txnDet.cleaningFees&&cleaningFeeApplies){
    cleaningFee = listing.txnDet.cleaningFees
  }
  return cleaningFee
}

export const getDeposit = (booking, listing) => {
  var deposit = ""
  if(booking.agreedDeal.priceTier=="month" && listing.txnDet.depositMonthly) deposit = listing.txnDet.depositMonthly
  else if(listing.txnDet.depositDaily) deposit = listing.txnDet.depositDaily

  return deposit
}


// WEBPACK FOOTER //
// ./src/bookings/bookingUtil.js